import { Currency } from '@search/filter-enums/enums/Currency';

export function getPriceForMicroLayout(currency: Currency) {
    if (currency === Currency.RUB) {
        return 'RUB';
    } else if (currency === Currency.EUR) {
        return 'EUR';
    } else if (currency === Currency.USD) {
        return 'USD';
    }

    return 'RUB';
}
